import Header from "@/components/site/Header";
import AnnouncementBar from "@/components/site/AnnouncementBar";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import About from "@/components/site/About";
import Services from "@/components/site/Services";
import Pricing from "@/components/site/Pricing";
import AutoDetailing from "@/components/site/AutoDetailing";
import WhyChooseUs from "@/components/site/WhyChooseUs";
import Gallery from "@/components/site/Gallery";
import Testimonials from "@/components/site/Testimonials";
import ServiceArea from "@/components/site/ServiceArea";
import FAQ from "@/components/site/FAQ";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import StickyMobileCTA from "@/components/site/StickyMobileCTA";

export default function Home() {
  return (
    <div data-testid="home-page" className="bg-white text-slate-900">
      <AnnouncementBar />
      <Header />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Services />
        <Pricing />
        <AutoDetailing />
        <WhyChooseUs />
        <Gallery />
        <Testimonials />
        <ServiceArea />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <StickyMobileCTA />
    </div>
  );
}
